
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import './PhotoBlock.scss'


export default function PhotoBlock(){

    const photos = [
        "./a2.jpg",
        "./img1.jpg",
        "./aa3.jpg",
        "./a1.jpg",
        "./a4.jpg",
        "./offer1.jpg",
        "./a6.jpg",
        "./a7.jpg",
        "./img2.jpg",
        "./img3.jpg"
    ]

    return(
        <div className="PhotoBlock">
            <Swiper
             breakpoints={{
            // when window width is >= 640px
            300: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            // when window width is >= 1024px
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          }}
                 modules={[Navigation, Pagination, Scrollbar, A11y]}
                navigation
                pagination={{ clickable: true }}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
            >

                {photos.map((el, index) => {
                    return <SwiperSlide key={index}>
                       <div className="img-block">
                            <img src={el} alt="children in class" />
                        </div> 
                    </SwiperSlide>
                })}
            </Swiper>
        </div>
    )
}